"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var Image_1 = __importDefault(require("@sportnet/ui/lib/Image"));

var em_1 = __importDefault(require("polished/lib/helpers/em"));

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Wrapper = styled_components_1["default"].a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  color: #1f1f1f;\n  box-shadow: 0 0 ", " 0 rgba(0, 0, 0, 0.2);\n  display: block;\n  ", " {\n    display: ", ";\n    max-width: ", ";\n  }\n  border-radius: ", ";\n  margin: auto;\n  overflow: hidden;\n  background-color: #fff;\n"], ["\n  text-decoration: none;\n  color: #1f1f1f;\n  box-shadow: 0 0 ", " 0 rgba(0, 0, 0, 0.2);\n  display: block;\n  ", " {\n    display: ", ";\n    max-width: ", ";\n  }\n  border-radius: ", ";\n  margin: auto;\n  overflow: hidden;\n  background-color: #fff;\n"])), em_1["default"](40), utilities_1.mb('s'), function (_a) {
  var leftOrRight = _a.leftOrRight;
  return leftOrRight ? 'flex' : 'block';
}, function (_a) {
  var leftOrRight = _a.leftOrRight;
  return leftOrRight ? em_1["default"](800) : em_1["default"](400);
}, function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
});
var PictureWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  ", " {\n    width: ", ";\n  }\n"], ["\n  width: 100%;\n  ", " {\n    width: ", ";\n  }\n"])), utilities_1.mb('s'), function (_a) {
  var leftOrRight = _a.leftOrRight;
  return leftOrRight ? '50%' : '100%';
});
var Name = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", ";\n  padding-bottom: ", ";\n  color: ", ";\n"], ["\n  font-size: ", ";\n  padding-bottom: ", ";\n  color: ", ";\n"])), em_1["default"](24), em_1["default"](10), function (_a) {
  var theme = _a.theme;
  return theme.color.primary;
});
var TextWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", ";\n  font-size: ", ";\n  width: 100%;\n  ", " {\n    width: ", ";\n  }\n"], ["\n  padding: ", ";\n  font-size: ", ";\n  width: 100%;\n  ", " {\n    width: ", ";\n  }\n"])), em_1["default"](10), em_1["default"](16), utilities_1.mb('s'), function (_a) {
  var leftOrRight = _a.leftOrRight;
  return leftOrRight ? '50%' : '100%';
});
var StyledImage = styled_components_1["default"](Image_1["default"])(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  max-height: 100%;\n  width: 100%;\n"], ["\n  max-height: 100%;\n  width: 100%;\n"])));
var Meta = styled_components_1["default"]('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: ", ";\n  margin-bottom: 0.5em;\n  color: ", ";\n"], ["\n  font-size: ", ";\n  margin-bottom: 0.5em;\n  color: ", ";\n"])), em_1["default"](14), function (_a) {
  var theme = _a.theme;
  return theme.color.fadedText;
});

var WidgetExternal =
/** @class */
function (_super) {
  __extends(WidgetExternal, _super);

  function WidgetExternal() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  WidgetExternal.prototype.render = function () {
    var _a = this.props,
        _b = _a.data,
        name = _b.name,
        perex = _b.perex,
        image = _b.image,
        openCurrentWindow = _b.openCurrentWindow,
        target = _b.target,
        photoPosition = _b.photoPosition,
        author = _b.author,
        source = _b.source,
        type = _b.type,
        renderEmpty = _a.renderEmpty;

    if (!target && renderEmpty) {
      return renderEmpty(type);
    }

    if (!target) {
      return null;
    }

    var leftOrRight = image && (photoPosition === 'left' || photoPosition === 'right');
    var meta = [];

    if (author) {
      meta.push("Autor: " + author);
    }

    if (source) {
      meta.push("Zdroj: " + source);
    }

    var text = react_1["default"].createElement(TextWrapper, {
      key: "TextWrapper",
      leftOrRight: leftOrRight
    }, meta.length > 0 && react_1["default"].createElement(Meta, null, meta.join(', ')), react_1["default"].createElement(Name, null, name), react_1["default"].createElement("div", null, perex));
    var picture = react_1["default"].createElement(PictureWrapper, {
      key: "PictureWrapper",
      leftOrRight: leftOrRight
    }, react_1["default"].createElement(StyledImage, {
      src: image
    }));
    var content = [picture, text];

    if (image) {
      if (photoPosition === 'top' || photoPosition === 'left') {
        content = [picture, text];
      } else if (photoPosition === 'bottom' || photoPosition === 'right') {
        content = [text, picture];
      }
    } else {
      content = text;
    }

    return react_1["default"].createElement(Wrapper, {
      href: target,
      target: openCurrentWindow ? '_self' : '_blank',
      leftOrRight: leftOrRight
    }, content);
  };

  return WidgetExternal;
}(react_1.PureComponent);

WidgetExternal.propTypes = {
  data: prop_types_1["default"].shape({
    name: prop_types_1["default"].string.isRequired,
    perex: prop_types_1["default"].string.isRequired,
    image: prop_types_1["default"].string,
    target: prop_types_1["default"].string.isRequired,
    openCurrentWindow: prop_types_1["default"].bool,
    photoPosition: prop_types_1["default"].string
  }).isRequired
};
exports["default"] = WidgetExternal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;